import * as types from "../constants/actionTypes";
import {
  setHasMultipleGroupCompanies,
  setGroupCompanyId,
  clearContext,
  setProjectId,
  setProject
} from "./contextActions";

const getClaimValueByName = (user, claimName) => {
  var claim = user.claims.find(c => c.type === claimName);
  if (claim) {
    return claim.value;
  }
  return null;
};

export const login = (token, expiresIn, user) => async dispatch => {
  var groupCompanyId = getClaimValueByName(user, "GroupCompanyId");
  var multipleGroupCompany = getClaimValueByName(user, "MultipleGroupCompany");
  var actions = [
    setProjectId(null),
    setProject(null),
    setGroupCompanyId(groupCompanyId ? parseInt(groupCompanyId) : null),
    setHasMultipleGroupCompanies(multipleGroupCompany === "1"),
    { type: types.AUTH_LOGIN, token, expiresIn, user, groupCompanyId }
  ];
  await Promise.all(actions.map(action => dispatch(action)));
};
export const logout = () => async dispatch => {
  await Promise.all([
    dispatch({ type: types.AUTH_LOGOUT }),
    dispatch(clearContext())
  ]);
};
